<template>
  <div>
    <support-modal
      :modal-id="supportModalId"
      :support="support"
      :support-categories="supportCategories"
      @submit-support-modal="sendSupport"
    />
    <preloader @hide-preloader="loadData" />
    <nav id="header" class="navbar-default navbar-fixed-top navbar navbar-header">
      <div class="container">
        <div class="navbar-header">
          <template v-if="isAuthorized">
            <button
              type="button"
              class="navbar-toggle collapsed"
              data-toggle="collapse"
              data-target="#header-collapse"
              aria-expanded="false"
              @click="collapse"
            >
              <span class="sr-only">Toggle navigation</span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
            </button>
            <router-link to="/" class="logo">
              <img src="../../public/img/logo.png" alt="logo" class="img-logo pull-left" />
            </router-link>
          </template>
          <template v-else>
            <span class="logo">
              <img src="../../public/img/logo.png" alt="logo" class="img-logo pull-left" />
            </span>
          </template>
        </div>
        <div id="header-collapse" class="collapse navbar-collapse">
          <ul class="navbar-nav navbar-right nav" @click="collapse">
            <li class="active-applications" v-if="visibleApplicationScreenLink">
              <router-link :to="{ name: 'ApplicationList'}">
                Заявки на пропуск
                <span class="badge" v-if="applicationScreenCounter">{{
                    applicationScreenCounter
                  }}</span>
              </router-link>
            </li>
            <li class="active-applications" v-if="visibleApplicationArchiveLink"
            >
              <router-link :to="{ name: 'ApplicationList', query: { archived:1 }}">
                Архив заявок
              </router-link>
            </li>
            <li class="active-applications" v-if="visibleGuardScreenLink">
              <a :href="guardScreenUrl">Посетители</a>
            </li>
            <user-menu-item :links="menuLinks" />
          </ul>
        </div>
      </div>
    </nav>
    <div class="main-container">
      <slot />
    </div>
    <div class="container">
      <div class="row" style="padding-bottom: 30px">
        <div class="col-md-6 col-xs-6">
          <div style="color: #aaa; margin-bottom: 10px">Оператор сервиса:</div>
          <img
            src="../../public/img/konversta.png"
            alt
            style="display: block; width: 150px"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Preloader from '../common/components/Preloader.vue'
import UserMenuItem from '../common/components/UserMenuItem.vue'
import { ApiClient } from '@/helpers/api-client/ApiClient'
import mainMixin from '../common/mixins/mainMixin'
import { UserRoles } from '@/enums/UserRoles'
import SupportModal from '../common/components/SupportModal'
import { Logger } from '@/common/helpers/Logger'
import { ResponseStatuses } from '@/enums/ResponseStatuses'
import { cloneObject } from '@/common/helpers'
import PermissionsMixin from '@/common/mixins/PermissionsMixin'
import PermissionsEnum from '@/common/enums/PermissionsEnum'

export default {
  name: 'MainLayout',
  mixins: [mainMixin, PermissionsMixin],
  metaInfo: {
    title: 'Сервис по оформлению заявок на пропуск'
  },

  data: () => {
    const defaultSupport = {
      sending: false,
      form: {
        category_id: null,
        theme: null,
        message: null
      },
      errors: []
    }

    return {
      applicationScreenCounter: null,
      supportModalId: 'support-modal',
      supportCategories: [],
      defaultSupport,
      support: cloneObject(defaultSupport)
    }
  },

  components: {
    Preloader,
    UserMenuItem,
    SupportModal
  },

  computed: {
    menuLinks () {
      return [
        {
          label: 'Панель управления',
          visible: this.visibleAdminPanelScreenLink,
          url: ApiClient.getAdminPanelScreenUrl()
        },
        {
          label: 'Посетители',
          visible: this.visibleVisitorScreenLink,
          to: { name: 'VisitorList' }
        },
        {
          label: 'Печать реестра заявок',
          visible: this.visibleBulletinLink,
          url: ApiClient.getBulletinUrl(),
          target: '_blank'
        },
        {
          label: 'Реестр выданных пропусков',
          visible: this.visibleIssuedPassesLink,
          to: { name: 'IssuedPassesList' }
        },
        {
          label: 'Личный кабинет',
          visible: true,
          url: ApiClient.getAccountUrl()
        },
        {
          label: 'Поддержка',
          visible: true,
          onClick: this.onClickSupportLink
        }
      ]
    },

    visibleAdminPanelScreenLink () {
      return this.user && (
        this.hasPermission(PermissionsEnum.pdfPassBackgroundAdminPanelPage) ||
        this.hasPermission(PermissionsEnum.pdfPassViewAdminPanelPage) ||
        this.hasPermission(PermissionsEnum.blacklistAdminPanelPage) ||
        this.hasPermission(PermissionsEnum.userAdminPanelPage)
      )
    },

    visibleVisitorScreenLink () {
      return (this.user)
    },

    visibleBulletinLink () {
      return (
        this.user &&
          this.user.role === UserRoles.SB
      )
    },

    visibleIssuedPassesLink () {
      return this.hasPermission(PermissionsEnum.canUseIssuedPassesPage)
    },

    applicationScreenUrl () {
      return ApiClient.getApplicationScreenUrl()
    },

    applicationArchiveUrl () {
      return ApiClient.getApplicationArchiveUrl()
    },

    guardScreenUrl () {
      return ApiClient.getGuardScreenUrl()
    },

    visibleApplicationScreenLink () {
      return true // this.user && this.user.role !== UserRoles.GUARD
    },

    visibleApplicationArchiveLink () {
      return this.visibleApplicationScreenLink
    },

    visibleGuardScreenLink () {
      return false // this.user && this.user.role === UserRoles.GUARD
    }
  },

  methods: {
    async loadData () {
      if (!this.user) {
        return
      }

      await ApiClient.mainHeaderData().then((response) => {
        const responseData = response.data

        if (!responseData.data) {
          return
        }

        this.applicationScreenCounter =
        responseData.data.applicationScreenCounter

        this.supportCategories = responseData.data.supportCategories
      })
    },

    async sendSupport () {
      Logger.log('Sending support message...')
      this.support.sending = true

      await ApiClient.sendSupport(this.support.form).then(response => {
        this.support.sending = false
        const result = response.data

        if (result.status === ResponseStatuses.Success) {
          this.$bvModal.hide(this.supportModalId)
          this.support = cloneObject(this.defaultSupport)
          Logger.log('Successfully sended support message...')
        } else {
          this.support.errors = result.errors
          Logger.log('Error while sending support message...')
        }
      })
    },

    onClickSupportLink () {
      this.$bvModal.show(this.supportModalId)
    },

    collapse() {
      let el = document.getElementById('header-collapse')
      el.classList.toggle('collapse')
      el.classList.toggle('shown')
    }
  }
}
</script>
